<div class="mb-3 irembogov-custom-dynamic-repeater">
  <!-- Items Container -->
  <div
    *ngFor="let fieldItem of field.fieldGroup; let i = index"
    class="d-flex custom-dynamic-repeater-item mb-3">
    <div class="w-100">
      <!-- Form Fields -->
      <formly-field
        class="repeater-group repeater-fields flex-grow-1"
        [field]="fieldItem">
      </formly-field>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!hasItems()" class="empty-state text-center text-muted py-4">
    <i class="fa-solid fa-inbox fa-2x mb-3"></i>
    <p class="mb-0">{{ getEmptyStateMessage() }}</p>
  </div>
</div>
